import React from 'react';
import { Star, ShieldCheck, Award, Camera } from 'lucide-react';
import { useT } from '../services/i18n';

/** Brand page: trust score from the brand's verified product reviews (weighted average, distribution, recommended products). */
const BrandTrustScore = ({ brand }) => {
  const { t } = useT();
  const total = brand.total_reviews || 0;
  const dist = brand.rating_distribution || {};
  return (
    <div id="confiance" className="mt-6 pt-5 border-t border-gray-100 scroll-mt-24" data-testid="brand-trust-score">
      <p className="text-xs font-semibold uppercase tracking-wider text-emerald-700 inline-flex items-center gap-1.5"><ShieldCheck size={13} /> {t('brand.trust.title')}</p>
      <div className="mt-2 flex flex-col sm:flex-row gap-5 sm:items-center">
        <div className="flex items-center gap-3">
          <span className="text-4xl font-black text-gray-900" data-testid="brand-trust-average">{Number(brand.avg_rating).toFixed(1)}</span>
          <div>
            <span className="inline-flex items-center gap-0.5">{[1, 2, 3, 4, 5].map(i => <Star key={i} size={16} className={i <= Math.round(brand.avg_rating) ? 'fill-yellow-400 text-yellow-400' : 'text-gray-300'} />)}</span>
            <p className="text-xs text-gray-600" data-testid="brand-trust-count">{t('brand.trust.summary', { n: total, count: total, p: brand.rated_products })}</p>
          </div>
        </div>
        <div className="flex-1 max-w-xs space-y-1" data-testid="brand-trust-distribution">
          {[5, 4, 3, 2, 1].map(star => {
            const c = dist[String(star)] || 0;
            return (
              <div key={star} className="flex items-center gap-2 text-[11px] text-gray-500">
                <span className="w-3 text-right">{star}</span><Star size={10} className="fill-yellow-400 text-yellow-400" />
                <div className="flex-1 h-1.5 bg-gray-100 rounded-full overflow-hidden"><div className="h-full bg-yellow-400" style={{ width: `${total ? (100 * c) / total : 0}%` }} /></div>
                <span className="w-5 text-right">{c}</span>
              </div>
            );
          })}
        </div>
        <div className="flex flex-wrap gap-2 text-xs">
          {brand.recommended_products > 0 && <span className="inline-flex items-center gap-1 font-semibold rounded-full bg-emerald-50 text-emerald-800 border border-emerald-200 px-2.5 py-1" data-testid="brand-trust-recommended"><Award size={12} /> {t('brand.trust.recommended', { n: brand.recommended_products, count: brand.recommended_products })}</span>}
          {brand.reviews_with_photos > 0 && <span className="inline-flex items-center gap-1 rounded-full bg-gray-100 text-gray-700 px-2.5 py-1" data-testid="brand-trust-photos"><Camera size={12} /> {t('reviews.withPhotos', { n: brand.reviews_with_photos, count: brand.reviews_with_photos })}</span>}
        </div>
      </div>
    </div>
  );
};

export default BrandTrustScore;
